import { z } from 'zod';

/**
 * User-facing appeals. This is part of the **user** contract (safe for mobile) —
 * a sanctioned account can contest a moderator decision. The admin-side review
 * views live in `admin/appeals.ts`.
 */

export const AppealStatusSchema = z.enum(['open', 'granted', 'denied']);
export type AppealStatus = z.infer<typeof AppealStatusSchema>;

/* POST /api/appeals */
export const CreateAppealSchema = z.object({
  body: z.string().min(10).max(1500),
});
export type CreateAppeal = z.infer<typeof CreateAppealSchema>;

export const MyAppealSchema = z.object({
  id: z.string(),
  sanction: z.string(),
  body: z.string(),
  status: AppealStatusSchema,
  decisionNote: z.string().nullable(),
  createdAt: z.iso.datetime(),
  reviewedAt: z.iso.datetime().nullable(),
});
export type MyAppeal = z.infer<typeof MyAppealSchema>;

/* GET /api/appeals/mine */
export const MyAppealsResponseSchema = z.object({
  appeals: z.array(MyAppealSchema),
  /** true when the account is under a sanction and has no open appeal. */
  canAppeal: z.boolean(),
});
export type MyAppealsResponse = z.infer<typeof MyAppealsResponseSchema>;
